module.exports = __webpack_public_path__ + "img/sprinter.0cb7a018.jpg";